import { render } from "./TableColumn.vue?vue&type=template&id=61daa964"
import script from "./TableColumn.vue?vue&type=script&lang=ts"
export * from "./TableColumn.vue?vue&type=script&lang=ts"
script.render = render

export default script